export default {
  title: "Trend Chart",
  recent_records: "Recent Records",
  preview_report: "Preview Report",
  compliant_status_good: "Compliant Status Good",
  custom_factor_status: "Using Custom Factor, Compliance Status Pending",
  tax_amount: "Tax Amount",
  based_on_eur: "Based on €{amount}",
  total_emission: "Total Emission",
  recent_calculation_date: "Recent Calculation Date",
  no_records: "No Records",
  calculate_now: "Calculate Now",
  cbam_news: "CBAM News",
  no_news: "No News",
  usage_stats_and_price: "Usage Statistics & Carbon Price",
  monthly_calculation_count: "Monthly Calculation Count",
  monthly_report_count: "Monthly Report Count",
  monthly_avg_emission: "Monthly Avg. Emission",
  today_carbon_price: "Today's Carbon Price",
  current_plan: "Current Plan: {plan}",
  upgrade_now: "Upgrade Now",
  trial_remaining: "{days} days remaining, {calculations} calculations, {reports} reports",
  expiry_date: "Expiry Date: {date}",
  free_plan_desc1: "100 calculations per month, 1 report per day",
  free_plan_desc2: "Upgrade to unlock more features!",
  trial_expired: "Trial expired, upgrade to pro plan (€99/month) to continue",
  config_fetch_failed: "Configuration Fetch Failed",
};
